module.exports = __webpack_public_path__ + "media/virtualStagingSlider/virtualStagingSlider5Post-eaffb30a.jpeg";